import React from "react";
// import { ReactComponent as Logo } from "../../assets/logo/logo.svg";

import { ReactComponent as Logo } from '../../assets/logo/gozowo.svg'
import { Link } from "react-router-dom";
const Footer = () => {
  // Categories Section
  const categoriesLinks = [
    { name: "Truck", href: "#" },
    { name: "Two Wheeler", href: "#" },
    { name: "Fork Lifter", href: "#" },
    { name: "Compact", href: "#" },
    { name: "Chiller", href: "#" },
    { name: "Trailer", href: "#" },
    { name: "Specialty", href: "#" },
  ];

  // Company Section
  const companyLinks = [
    { name: "Careers", href: "#" },
    { name: "About Us", href: "/about" },
    { name: "Blogs", href: "/blog" },
    { name: "Contact Us", href: "/contact" },
    { name: "Safety", href: "#" },
  ];

  // Legal Section
  const legalLinks = [
    // { name: "Terms of Service", href: "#" },
    // { name: "Privacy Policy", href: "#" },
    { name: "Terms of Service", href: "/terms-and-conditions" },
    { name: "Privacy Policy", href: "/privacy-policy" },
    // { name: "Refund Policy", href: "/refund-policy" },
    // { name: "Shipping Policy", href: "/shipping-policy" },
    // { name: "Return Policy", href: "/return-policy" },
    // { name: "Cancellation Policy", href: "/cancellation-policy" },
    // { name: "Terms and Conditions", href: "/terms-and-conditions" },
    // { name: "Privacy Policy", href: "/privacy-policy" },
    // { name: "Refund Policy", href: "/refund-policy" },
    // { name: "Shipping Policy", href: "/shipping-policy" },
    // { name: "Return Policy", href: "/return-policy" },
    // { name: "Cancellation Policy", href: "/cancellation-policy" },
  ];

  // Contact Us Section (without icons or dropdown)
  const contactInfo = [
    { type: "email", value: "gozowo@douxl.com" },
    { type: "phone", value: "+971-000-00000" },
    { type: "address", value: "Lorem Ipsum, street 232, dior letus 34, Dubai" },
    { type: "support", value: "Help Center" },
  ];

  return (
    <div>
      <div className="footer-container">
        <div className="qr-code">
          <Logo></Logo>
          {/* <svg
            xmlns="http://www.w3.org/2000/svg"
            width="158"
            height="30"
            viewBox="0 0 158 30"
            fill="none"
          >
            <g>
              <path
                d="M8.03051 24.2836L12.2113 0.416992H5.13298L0 29.7079H16.3507L17.3024 24.2836H8.03051Z"
                fill="#001871"
              />
              <path
                d="M49.2999 5.82031C48.2787 3.97114 46.8299 2.53859 44.9536 1.52268C43.0767 0.507719 40.8969 0 38.4137 0C35.1019 0 32.1425 0.750791 29.5346 2.25285C26.9268 3.75491 24.8911 5.8486 23.429 8.53246C21.966 11.2173 21.2349 14.2698 21.2349 17.6911C21.2349 20.1112 21.7453 22.2533 22.7664 24.1169C23.7871 25.9809 25.2297 27.4274 27.0923 28.4562C28.9548 29.4856 31.1137 30 33.5703 30C36.9092 30 39.8895 29.2425 42.5117 27.7261C45.1329 26.2101 47.1747 24.0958 48.6378 21.3836C50.1003 18.672 50.8314 15.605 50.8314 12.1833C50.8314 9.79145 50.3206 7.67092 49.2999 5.82031ZM42.6563 18.171C41.8972 19.7708 40.828 21.0437 39.4482 21.9887C38.0679 22.9346 36.4679 23.4073 34.6467 23.4073C32.6319 23.4073 31.0723 22.8306 29.9694 21.6761C28.8649 20.5221 28.3132 18.9429 28.3132 16.9403C28.3132 15.0489 28.6923 13.3172 29.4519 11.7456C30.2105 10.174 31.2868 8.91552 32.6804 7.96912C34.0736 7.02416 35.6817 6.55048 37.5028 6.55048C39.4895 6.55048 41.0349 7.12101 42.1388 8.26158C43.2422 9.40215 43.7945 10.9737 43.7945 12.9763C43.7945 14.8403 43.4149 16.5721 42.6563 18.171Z"
                fill="#001871"
              />
              <path
                d="M79.7039 5.90362C78.669 4.16567 77.1788 2.81607 75.233 1.85673C73.2877 0.896904 70.9761 0.416992 68.2998 0.416992H57.4131L52.2806 29.7079H63.1668C66.2023 29.7079 68.9828 29.0962 71.5079 27.8722C74.033 26.6482 76.1163 24.9237 77.7581 22.6981C79.3995 20.4731 80.4697 17.9278 80.9663 15.0622C81.1589 13.8387 81.2559 12.8237 81.2559 12.0164C81.2559 9.6801 80.7384 7.64252 79.7039 5.90362ZM73.7638 15.0622C73.3219 17.7609 72.218 19.8608 70.4525 21.3629C68.686 22.865 66.4643 23.6158 63.788 23.6158H60.4348L63.4151 6.50866H66.8096C69.0998 6.50866 70.8663 7.07199 72.1081 8.19866C73.35 9.32532 73.9707 10.918 73.9707 12.9762C73.9707 13.5328 73.9017 14.228 73.7638 15.0622Z"
                fill="#001871"
              />
              <path
                d="M90.4455 24.0749H101.166L100.173 29.7078H82.3736L85.4543 12.1289H92.5583L92.5564 12.1414H102.036L101.083 17.524H91.6046L90.4455 24.0749Z"
                fill="#001871"
              />
              <path
                d="M105.306 0.416992L104.314 6.03978H86.5211L87.5066 0.416992H105.306Z"
                fill="#FFD700"
              />
              <path
                d="M128.652 2.48239C127.079 1.10546 124.788 0.416992 121.78 0.416992H109.901L104.768 29.7079H111.846L113.791 18.6508H115.489L119.587 29.7079H127.575L122.898 18.1085C125.161 17.469 126.968 16.384 128.321 14.8537C129.673 13.3243 130.514 11.5854 130.846 9.63839C130.956 9.08225 131.011 8.4844 131.011 7.84388C131.011 5.64712 130.225 3.85932 128.652 2.48239ZM123.602 9.93037C123.38 11.0987 122.891 12.003 122.132 12.6425C121.373 13.2826 120.345 13.6019 119.048 13.6019H114.661L115.944 6.2584H120.332C121.435 6.2584 122.27 6.50243 122.836 6.98857C123.401 7.47567 123.685 8.16414 123.685 9.05397C123.685 9.19348 123.657 9.48545 123.602 9.93037Z"
                fill="#001871"
              />
              <path
                d="M155.64 2.48239C154.068 1.10546 151.777 0.416992 148.769 0.416992H136.889L131.756 29.7079H138.835L140.78 18.6508H142.477L146.575 29.7079H154.565L149.887 18.1085C152.149 17.469 153.957 16.384 155.309 14.8537C156.661 13.3243 157.503 11.5854 157.834 9.63839C157.944 9.08225 158 8.4844 158 7.84388C158 5.64712 157.214 3.85932 155.64 2.48239ZM150.591 9.93037C150.369 11.0987 149.88 12.003 149.121 12.6425C148.362 13.2826 147.334 13.6019 146.037 13.6019H141.649L142.933 6.2584H147.321C148.424 6.2584 149.259 6.50243 149.825 6.98857C150.39 7.47567 150.673 8.16414 150.673 9.05397C150.673 9.19348 150.645 9.48545 150.591 9.93037Z"
                fill="#001871"
              />
            </g>
            <defs>
              <clipPath id="clip0_1701_2722">
                <rect width="158" height="30" fill="white" />
              </clipPath>
            </defs>
          </svg> */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="150"
            height="150"
            viewBox="0 0 150 150"
            fill="none"
          >
            <g>
              <path
                d="M56.25 0H0V56.25H56.25V0ZM46.875 46.875H9.375V9.375H46.875V46.875Z"
                fill="#101010"
              />
              <path
                d="M18.75 18.75H37.5V37.5H18.75V18.75ZM0 150H56.25V93.75H0V150ZM9.375 103.125H46.875V140.625H9.375V103.125Z"
                fill="#101010"
              />
              <path
                d="M18.75 112.5H37.5V131.25H18.75V112.5ZM93.75 0V56.25H150V0H93.75ZM140.625 46.875H103.125V9.375H140.625V46.875Z"
                fill="#101010"
              />
              <path
                d="M112.5 18.75H131.25V37.5H112.5V18.75ZM18.75 65.625H0V84.375H28.125V75H18.75V65.625ZM65.625 84.375H84.375V103.125H65.625V84.375ZM28.125 65.625H46.875V75H28.125V65.625ZM84.375 112.5H65.625V121.875H75V131.25H84.375V121.875V112.5ZM56.25 65.625V75H46.875V84.375H65.625V65.625H56.25ZM75 37.5H84.375V56.25H75V37.5ZM84.375 75V84.375H103.125V65.625H75V75H84.375ZM65.625 56.25H75V65.625H65.625V56.25ZM84.375 131.25H103.125V150H84.375V131.25ZM65.625 131.25H75V150H65.625V131.25ZM84.375 103.125H93.75V112.5H84.375V103.125ZM84.375 28.125V9.375H75V0H65.625V37.5H75V28.125H84.375ZM112.5 131.25H121.875V150H112.5V131.25ZM112.5 112.5H131.25V121.875H112.5V112.5ZM103.125 121.875H112.5V131.25H103.125V121.875ZM93.75 112.5H103.125V121.875H93.75V112.5ZM131.25 93.75V103.125H140.625V112.5H150V93.75H140.625H131.25ZM140.625 121.875H131.25V150H150V131.25H140.625V121.875ZM93.75 93.75V103.125H121.875V84.375H103.125V93.75H93.75ZM112.5 65.625V75H131.25V84.375H150V65.625H131.25H112.5Z"
                fill="#101010"
              />
            </g>
            <defs>
              <clipPath id="clip0_1139_1907">
                <rect width="150" height="150" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
        <div className="footer-list-container">
          <div className="list">
            <span>Categories</span>
            <ul>
              {categoriesLinks.map((link) => {
                return <li key={link.name}>{link.name}</li>;
              })}
            </ul>
          </div>
          <div className="list">
            <span>Company</span>
            <ul>
              {companyLinks.map((link) => {
                return (
                  <a key={link.name} className="page-link" href={link.href}>
                    <li>{link.name}</li>
                  </a>
                );
              })}
            </ul>
          </div>
          <div className="list">
            <span>Legal</span>
            <ul>
              {legalLinks.map((link) => {
                return <Link key={link.name} className="page-link" to={link.href}><li>{link.name}</li></Link>;
              })}
            </ul>
          </div>
          <div className="list">
            <span>Contact Us</span>
            <ul>
              {contactInfo.map((link, index) => {
                return (
                  <div key={index}>
                    {index == 0 ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M3.33366 16.6654C2.87533 16.6654 2.4831 16.5023 2.15699 16.1762C1.83088 15.8501 1.66755 15.4576 1.66699 14.9987V4.9987C1.66699 4.54036 1.83033 4.14814 2.15699 3.82203C2.48366 3.49592 2.87588 3.33259 3.33366 3.33203H16.667C17.1253 3.33203 17.5178 3.49536 17.8445 3.82203C18.1712 4.1487 18.3342 4.54092 18.3337 4.9987V14.9987C18.3337 15.457 18.1706 15.8495 17.8445 16.1762C17.5184 16.5029 17.1259 16.6659 16.667 16.6654H3.33366ZM10.0003 10.6862C10.0698 10.6862 10.1428 10.6756 10.2195 10.6545C10.2962 10.6334 10.3689 10.6023 10.4378 10.5612L16.3337 6.8737C16.4448 6.80425 16.5281 6.71759 16.5837 6.6137C16.6392 6.50981 16.667 6.39509 16.667 6.26953C16.667 5.99175 16.5489 5.78342 16.3128 5.64453C16.0767 5.50564 15.8337 5.51259 15.5837 5.66536L10.0003 9.16536L4.41699 5.66536C4.16699 5.51259 3.92394 5.50925 3.68783 5.65536C3.45171 5.80148 3.33366 6.0062 3.33366 6.26953C3.33366 6.40842 3.36144 6.53009 3.41699 6.63453C3.47255 6.73898 3.55588 6.8187 3.66699 6.8737L9.56283 10.5612C9.63227 10.6029 9.70533 10.6343 9.78199 10.6554C9.85866 10.6765 9.93144 10.6868 10.0003 10.6862Z"
                          fill="#101010"
                        />
                      </svg>
                    ) : index == 1 ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M15 8.125H13.75C13.7495 7.62787 13.5518 7.15125 13.2003 6.79972C12.8488 6.4482 12.3721 6.2505 11.875 6.25V5C12.7035 5.00099 13.4978 5.33055 14.0836 5.91639C14.6694 6.50222 14.999 7.2965 15 8.125Z"
                          fill="#101010"
                        />
                        <path
                          d="M17.5004 8.12501H16.2504C16.2487 6.96519 15.7873 5.85335 14.9671 5.03324C14.147 4.21313 13.0352 3.75166 11.8754 3.75001V2.50001C13.3667 2.50166 14.7965 3.09482 15.851 4.14936C16.9056 5.20389 17.4987 6.63367 17.5004 8.12501ZM12.7085 13.4263L14.1085 12.0263C14.296 11.839 14.5343 11.7108 14.7939 11.6575C15.0535 11.6042 15.323 11.6281 15.5691 11.7263L17.2741 12.4088C17.5253 12.5095 17.7405 12.6831 17.8922 12.9072C18.0439 13.1313 18.1251 13.3956 18.1254 13.6663V16.7669C18.1258 16.9512 18.0886 17.1336 18.0161 17.303C17.9436 17.4725 17.8373 17.6253 17.7037 17.7522C17.57 17.8791 17.4119 17.9774 17.239 18.0411C17.066 18.1047 16.8819 18.1325 16.6979 18.1225C4.74663 17.3788 2.33288 7.25626 1.88475 3.38001C1.86305 3.1905 1.88171 2.99855 1.93951 2.81678C1.99731 2.63501 2.09294 2.46753 2.22011 2.32537C2.34728 2.1832 2.5031 2.06957 2.67734 1.99195C2.85157 1.91433 3.04026 1.87447 3.231 1.87501H6.27663C6.54724 1.87525 6.81159 1.95644 7.03568 2.10814C7.25978 2.25984 7.43337 2.4751 7.53413 2.72626L8.216 4.43126C8.31416 4.6774 8.33806 4.94692 8.28474 5.2065C8.23143 5.46608 8.10324 5.70435 7.916 5.89188L6.516 7.29188C6.516 7.29188 7.29225 12.7494 12.7085 13.4263Z"
                          fill="#101010"
                        />
                      </svg>
                    ) : index == 2 ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M9.38468 18.4463C9.38468 18.4463 3.33301 13.3496 3.33301 8.33464C3.33301 6.56653 4.03539 4.87083 5.28563 3.62059C6.53587 2.37035 8.23156 1.66797 9.99967 1.66797C11.7678 1.66797 13.4635 2.37035 14.7137 3.62059C15.964 4.87083 16.6663 6.56653 16.6663 8.33464C16.6663 13.3496 10.6147 18.4463 10.6147 18.4463C10.278 18.7563 9.72384 18.753 9.38468 18.4463ZM9.99967 11.2513C10.3827 11.2513 10.762 11.1759 11.1158 11.0293C11.4697 10.8827 11.7912 10.6679 12.0621 10.397C12.3329 10.1262 12.5477 9.80466 12.6943 9.4508C12.8409 9.09693 12.9163 8.71766 12.9163 8.33464C12.9163 7.95161 12.8409 7.57234 12.6943 7.21848C12.5477 6.86461 12.3329 6.54308 12.0621 6.27224C11.7912 6.0014 11.4697 5.78656 11.1158 5.63999C10.762 5.49341 10.3827 5.41797 9.99967 5.41797C9.22613 5.41797 8.48426 5.72526 7.93728 6.27224C7.3903 6.81922 7.08301 7.56109 7.08301 8.33464C7.08301 9.10818 7.3903 9.85005 7.93728 10.397C8.48426 10.944 9.22613 11.2513 9.99967 11.2513Z"
                          fill="#101010"
                        />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <circle
                          cx="10"
                          cy="10"
                          r="9.5"
                          fill="#101010"
                          stroke="#101010"
                        />
                        <path
                          d="M9.20609 12.3233V12.0219C9.20609 11.379 9.63232 10.726 10.4848 10.063C10.9438 9.70137 11.2763 9.38493 11.4824 9.1137C11.6885 8.84247 11.7916 8.50594 11.7916 8.10411C11.7916 7.58174 11.6323 7.14475 11.3138 6.79315C11.0047 6.44155 10.6019 6.26575 10.1054 6.26575C9.54333 6.26575 9.08431 6.4516 8.72834 6.82329C8.38173 7.18493 8.20843 7.66712 8.20843 8.26986H7C7 7.35571 7.29508 6.58219 7.88525 5.94932C8.47541 5.31644 9.21546 5 10.1054 5C10.9578 5 11.6511 5.30137 12.185 5.90411C12.7283 6.50685 13 7.23014 13 8.07397C13 8.67671 12.8642 9.18904 12.5925 9.61096C12.3208 10.0329 11.9649 10.4247 11.5246 10.7863C11.4871 10.8164 11.4122 10.8767 11.2998 10.9671C11.1967 11.0575 11.1218 11.1228 11.0749 11.163C11.0281 11.2032 10.9578 11.2635 10.8642 11.3438C10.7799 11.4242 10.719 11.4945 10.6815 11.5548C10.644 11.605 10.5972 11.6703 10.541 11.7507C10.4941 11.821 10.4614 11.8963 10.4426 11.9767C10.4239 12.047 10.4145 12.1224 10.4145 12.2027V12.3233H9.20609ZM10.5269 15.6685C10.3302 15.8895 10.0867 16 9.79625 16C9.50585 16 9.25761 15.8895 9.05152 15.6685C8.8548 15.4475 8.75644 15.1813 8.75644 14.8699C8.75644 14.5685 8.85948 14.3073 9.06557 14.0863C9.27166 13.8553 9.51522 13.7397 9.79625 13.7397C10.0773 13.7397 10.3208 13.8553 10.5269 14.0863C10.733 14.3073 10.8361 14.5685 10.8361 14.8699C10.8361 15.1813 10.733 15.4475 10.5269 15.6685Z"
                          fill="white"
                        />
                      </svg>
                    )}
                    <li>{link.value}</li>
                  </div>
                );
              })}
            </ul>
          </div>
        </div>
        <div className="border-container">
          <div className="footer-border"></div>
        </div>
      </div>
      <div className="footer-wrapper">
        <div>
          <span>Zowo</span>
          <div className="copyright">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="29"
              height="29"
              viewBox="0 0 29 29"
              fill="none"
            >
              <circle cx="14.5" cy="14.5" r="13.5" stroke="#101010" />
            </svg>
            <span>c</span>
          </div>
          <span>2025</span>
        </div>
        <div className="social-icons">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
          >
            <path
              d="M13.5106 2.07422C14.6773 2.07733 15.2694 2.08355 15.7807 2.09807L15.9819 2.10533C16.2142 2.11363 16.4434 2.124 16.7203 2.13644C17.8237 2.1883 18.5766 2.36252 19.2373 2.61868C19.9217 2.88209 20.4983 3.23884 21.0749 3.81441C21.6025 4.33267 22.0106 4.95982 22.2707 5.65209C22.5268 6.3127 22.7011 7.06561 22.7529 8.17009C22.7653 8.44594 22.7757 8.67514 22.784 8.90848L22.7902 9.10967C22.8058 9.6199 22.812 10.2121 22.8141 11.3788L22.8151 12.1524V13.511C22.8177 14.2674 22.8097 15.0238 22.7913 15.7801L22.7851 15.9813C22.7768 16.2146 22.7664 16.4438 22.7539 16.7196C22.7021 17.8241 22.5258 18.576 22.2707 19.2376C22.0106 19.9299 21.6025 20.5571 21.0749 21.0753C20.5567 21.6029 19.9295 22.0109 19.2373 22.2711C18.5766 22.5272 17.8237 22.7014 16.7203 22.7533L15.9819 22.7844L15.7807 22.7906C15.2694 22.8051 14.6773 22.8124 13.5106 22.8145L12.7369 22.8155H11.3794C10.6226 22.8182 9.86584 22.8102 9.10928 22.7917L8.90809 22.7854C8.6619 22.7761 8.41577 22.7654 8.1697 22.7533C7.06626 22.7014 6.31335 22.5272 5.65171 22.2711C4.95981 22.0108 4.33302 21.6027 3.81506 21.0753C3.28714 20.5572 2.87871 19.93 2.61829 19.2376C2.36214 18.577 2.18791 17.8241 2.13606 16.7196L2.10494 15.9813L2.09976 15.7801C2.08064 15.0239 2.072 14.2674 2.07383 13.511V11.3788C2.07096 10.6223 2.07857 9.86589 2.09665 9.10967L2.10391 8.90848C2.1122 8.67514 2.12257 8.44594 2.13502 8.17009C2.18687 7.06561 2.3611 6.31374 2.61725 5.65209C2.87828 4.95954 3.28743 4.33236 3.8161 3.81441C4.33376 3.28712 4.96018 2.87906 5.65171 2.61868C6.31335 2.36252 7.06522 2.1883 8.1697 2.13644C8.44556 2.124 8.67579 2.11363 8.90809 2.10533L9.10928 2.09911C9.8655 2.08068 10.6219 2.07273 11.3784 2.07526L13.5106 2.07422ZM12.4445 7.25954C11.0692 7.25954 9.75034 7.80585 8.7779 8.77829C7.80547 9.75073 7.25916 11.0696 7.25916 12.4449C7.25916 13.8201 7.80547 15.139 8.7779 16.1114C9.75034 17.0839 11.0692 17.6302 12.4445 17.6302C13.8197 17.6302 15.1386 17.0839 16.1111 16.1114C17.0835 15.139 17.6298 13.8201 17.6298 12.4449C17.6298 11.0696 17.0835 9.75073 16.1111 8.77829C15.1386 7.80585 13.8197 7.25954 12.4445 7.25954ZM12.4445 9.33367C12.853 9.3336 13.2576 9.41401 13.6351 9.5703C14.0126 9.72659 14.3556 9.9557 14.6446 10.2446C14.9335 10.5334 15.1628 10.8763 15.3192 11.2538C15.4756 11.6312 15.5561 12.0358 15.5562 12.4443C15.5563 12.8529 15.4759 13.2575 15.3196 13.635C15.1633 14.0125 14.9342 14.3555 14.6453 14.6444C14.3565 14.9334 14.0135 15.1626 13.6361 15.319C13.2586 15.4755 12.8541 15.556 12.4455 15.5561C11.6204 15.5561 10.829 15.2283 10.2456 14.6448C9.66211 14.0614 9.33432 13.27 9.33432 12.4449C9.33432 11.6197 9.66211 10.8284 10.2456 10.2449C10.829 9.66146 11.6204 9.33367 12.4455 9.33367M17.8901 5.70395C17.5463 5.70395 17.2166 5.84052 16.9735 6.08363C16.7304 6.32674 16.5938 6.65647 16.5938 7.00028C16.5938 7.34408 16.7304 7.67381 16.9735 7.91692C17.2166 8.16003 17.5463 8.29661 17.8901 8.29661C18.2339 8.29661 18.5636 8.16003 18.8068 7.91692C19.0499 7.67381 19.1864 7.34408 19.1864 7.00028C19.1864 6.65647 19.0499 6.32674 18.8068 6.08363C18.5636 5.84052 18.2339 5.70395 17.8901 5.70395Z"
              fill="#101010"
            />
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="26"
            height="26"
            viewBox="0 0 26 26"
            fill="none"
          >
            <path
              d="M10.8579 15.6313V9.80304L16.4612 12.7276L10.8579 15.6313ZM23.1627 8.79398C23.1627 8.79398 22.9604 7.36386 22.3382 6.73437C21.55 5.90886 20.6654 5.90471 20.2599 5.85597C17.3582 5.64648 13.0036 5.64648 13.0036 5.64648H12.9953C12.9953 5.64648 8.64169 5.64648 5.73894 5.85597C5.33345 5.90471 4.44987 5.90782 3.66066 6.73437C3.03842 7.36386 2.8362 8.79398 2.8362 8.79398C2.8362 8.79398 2.62878 10.4719 2.62878 12.151V13.7242C2.62878 15.4022 2.8362 17.0812 2.8362 17.0812C2.8362 17.0812 3.03842 18.5102 3.66066 19.1397C4.44883 19.9663 5.4859 19.9393 5.94739 20.0264C7.6067 20.1851 12.9994 20.2338 12.9994 20.2338C12.9994 20.2338 17.3582 20.2276 20.2599 20.0181C20.6654 19.9694 21.55 19.9663 22.3382 19.1397C22.9604 18.5102 23.1627 17.0812 23.1627 17.0812C23.1627 17.0812 23.3701 15.4022 23.3701 13.7242V12.151C23.3701 10.4719 23.1627 8.79398 23.1627 8.79398Z"
              fill="#101010"
            />
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M9.99962 0.49707C8.31223 0.496905 6.65585 0.950555 5.20403 1.81049C3.7522 2.67042 2.55837 3.90499 1.74761 5.38484C0.936856 6.86469 0.539015 8.53535 0.595774 10.2218C0.652534 11.9082 1.1618 13.5484 2.07023 14.9703L0.471073 18.6706C0.412545 18.806 0.393726 18.9552 0.416811 19.1009C0.439896 19.2466 0.503933 19.3827 0.601452 19.4934C0.69897 19.6041 0.825949 19.6847 0.967574 19.726C1.1092 19.7672 1.25963 19.7673 1.40132 19.7263L5.95922 18.4041C7.23385 19.0093 8.6283 19.3201 10.0393 19.3135C11.4503 19.3068 12.8418 18.9828 14.1106 18.3656C15.3795 17.7483 16.4932 16.8535 17.3694 15.7475C18.2456 14.6415 18.8618 13.3525 19.1724 11.9761C19.483 10.5996 19.48 9.17098 19.1636 7.79587C18.8472 6.42076 18.2256 5.13442 17.3447 4.0321C16.4639 2.92978 15.3464 2.03971 14.0749 1.42779C12.8035 0.815874 11.4107 0.497783 9.99962 0.49707ZM11.4225 12.7604C11.0367 12.9885 10.1915 13.058 8.58507 11.4516C6.97865 9.84517 7.04814 9.001 7.27629 8.61418C7.85705 8.55506 8.41395 8.16616 8.93041 7.64971C9.31309 7.26703 9.00301 6.33886 8.23973 5.57558C7.47541 4.81126 6.54724 4.50221 6.1656 4.88385C3.70568 7.34274 4.93771 10.569 7.20266 12.835C9.49872 15.1311 12.6348 16.3901 15.1538 13.8721C15.5355 13.4894 15.2264 12.5612 14.4621 11.798C13.6978 11.0336 12.7696 10.7246 12.388 11.1062C11.8705 11.6227 11.4816 12.1796 11.4235 12.7604"
              fill="#101010"
            />
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="26"
            viewBox="0 0 25 26"
            fill="none"
          >
            <path
              d="M14.0669 23.4233C18.9338 22.6932 22.6662 18.4941 22.6662 13.4239C22.6662 7.83929 18.1395 3.3125 12.5549 3.3125C6.97027 3.3125 2.44348 7.83929 2.44348 13.4239C2.44348 18.4951 6.17588 22.6932 11.0428 23.4233V16.3733H8.91684C8.78317 16.3733 8.65497 16.3202 8.56045 16.2257C8.46593 16.1312 8.41283 16.003 8.41283 15.8693V13.958C8.41283 13.679 8.63891 13.454 8.91684 13.454H11.0428L10.9682 11.4389C10.9682 10.462 11.1496 8.87635 12.3599 8.00937C13.2061 7.40476 13.8356 7.29068 14.8457 7.29068C15.7221 7.29068 16.3246 7.37779 16.7228 7.43587L16.9178 7.4618C16.9661 7.4681 17.0104 7.49181 17.0425 7.52846C17.0746 7.56512 17.0922 7.61221 17.092 7.66091V9.77652C17.092 9.89371 16.9935 9.98394 16.8794 9.97772H16.84C16.7218 9.98186 16.1037 10.0078 15.5789 10.0078C14.656 10.0078 14.0669 10.4288 14.0669 11.8278V13.454H16.3401C16.6513 13.454 16.8888 13.734 16.8379 14.0409L16.5476 15.9522C16.5279 16.0698 16.4673 16.1767 16.3763 16.2538C16.2854 16.3309 16.17 16.3732 16.0508 16.3733H14.0669V23.4233Z"
              fill="#101010"
            />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default Footer;
